import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmbeddedNewpasswordPageRoutingModule } from './embedded-newpassword-routing.module';

import { EmbeddedNewpasswordPage } from './embedded-newpassword.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    EmbeddedNewpasswordPageRoutingModule
  ],
  declarations: [EmbeddedNewpasswordPage]
})
export class EmbeddedNewpasswordPageModule {}
